import React from 'react';
var styles = require("./checkbox.scss");
var Checkbox = function (props) { return (React.createElement("div", { className: styles.container },
    React.createElement("div", null,
        React.createElement("div", { className: props.checked ? styles.selected : styles.checkbox, onClick: props.action, "data-test": props.dataTest }),
        React.createElement("div", { className: styles.text }, props.text)))); };
export default Checkbox;
